// @flow
import * as React from 'react'

export function Property(props: { keyName: string, children?: React.Node }) {
  return (
    <tr className={`property ${props.keyName.toLowerCase()}`}>
      <td
        className='title six wide top aligned'
        colSpan={props.children ? '1' : '2'}
      >
        {props.keyName}
      </td>
      {!!props.children && <td className=''>{props.children}</td>}
    </tr>
  )
}

export default Property
